import { styled } from 'dripsy';
import React from 'react';
import { View } from 'react-native';

import { BaseText, IconTouchable } from '@components';

const Container = styled(View)({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  pr: '$6',
});

const HeaderText = styled(BaseText)({
  variant: 'text.xlarge',
});

interface ISectionHeaderProps {
  text: string;
  icon: string;
  onPress: () => void;
}

export function SectionHeader(props: ISectionHeaderProps) {
  return (
    <Container>
      <HeaderText>{props.text}</HeaderText>
      <IconTouchable
        onPress={props.onPress}
        name={props.icon}
        size={24}
      />
    </Container>
  );
}
